module.exports = __webpack_public_path__ + "img/icon-08.ef2a5ec5.png";